const socialMedia = {
   facebook: "https://facebook.com/poprostudasie",
   instagram: "https://www.instagram.com/poprostudasie/",
   youtube: "https://www.youtube.com/channel/UC7T0yl4HQwfiwrN8sITeTHw",
};

export default socialMedia;
